// SPDX-License-Identifier: AGPL-3.0-or-later
// SPDX-FileCopyrightText: 2026 Dobrev IT Ltd

import { isNativeApp } from "./server";

// Foreground new-message notifications via local notifications — scheduled by the
// app itself while it's running/connected, so NO Firebase/FCM is needed (that's only
// for background delivery when the app is suspended). Native-only; the web is a
// no-op. The plugin is imported dynamically so it never loads in the web bundle.

let inited = false;

// initNotify requests permission once and wires tap-to-open. Call after login.
export async function initNotify(onOpenRoom: (roomID: string) => void): Promise<void> {
  if (!isNativeApp() || inited) {
    return;
  }
  inited = true;
  try {
    const { LocalNotifications } = await import("@capacitor/local-notifications");
    const perm = await LocalNotifications.checkPermissions();
    if (perm.display === "prompt" || perm.display === "prompt-with-rationale") {
      await LocalNotifications.requestPermissions();
    }
    await LocalNotifications.addListener("localNotificationActionPerformed", (action) => {
      const roomID = action.notification.extra?.roomID as string | undefined;
      if (roomID) {
        onOpenRoom(roomID);
      }
    });
  } catch {
    /* unsupported platform */
  }
}

let nextId = 1;

// notifyMessage shows a local notification for a new message (native only).
export async function notifyMessage(roomID: string, title: string, body: string): Promise<void> {
  if (!isNativeApp()) {
    return;
  }
  try {
    const { LocalNotifications } = await import("@capacitor/local-notifications");
    await LocalNotifications.schedule({
      notifications: [{ id: nextId++ % 2147480000, title, body, extra: { roomID } }],
    });
  } catch {
    /* permission denied / unsupported */
  }
}
